import { render, staticRenderFns } from "./followers.vue?vue&type=template&id=ec87982e"
import script from "./followers.vue?vue&type=script&lang=js"
export * from "./followers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports